(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloController', RuoloController);

    RuoloController.$inject = ['$scope', '$state', 'Ruolo', 'RuoloSearch'];

    function RuoloController ($scope, $state, Ruolo, RuoloSearch) {
        var vm = this;
        
        vm.ruolos = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Ruolo.query(function(result) {
                vm.ruolos = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            RuoloSearch.query({query: vm.searchQuery}, function(result) {
                vm.ruolos = result;
            });
        }
   }
})();
